import type { IconComponent } from '@digital-twins/design-system/icons'
import { cn } from '@/lib/utils'

interface HomeUtilityChipProps {
  icon: IconComponent
  label: string
  onClick?: () => void
  variant?: 'dark' | 'light'
  className?: string
}

export function HomeUtilityChip({
  icon: Icon,
  label,
  onClick,
  variant = 'dark',
  className,
}: HomeUtilityChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'inline-flex min-h-[30px] shrink-0 items-center justify-center gap-[4px] whitespace-nowrap rounded-[4px] px-[12px] py-[4px] text-[16px] font-medium leading-[1.4] tracking-[-0.32px] transition-all duration-200',
        'bg-[var(--home-chip-bg)] text-[var(--home-chip-fg)] hover:bg-[var(--home-chip-bg-hover)]',
        variant === 'dark' && 'backdrop-blur-[4.55px]',
        className,
      )}
    >
      <Icon
        className={cn(
          'h-[14px] w-[14px] shrink-0',
          'text-[var(--home-chip-icon)]',
        )}
        strokeWidth={1.8}
      />
      <span>
        {label}
      </span>
    </button>
  )
}
